<template>
  <div>
    <div class="bg" style="background-color:#E8E8E8"></div>
    <div class="u-hd">
        <div class="hd-bk" @click="closeModle">
            <i class="icon iconback"></i>&nbsp;返回
        </div>
        <div class="hd-tl">对账单详情</div>
        <div class="hd-mu">
            <div style="padding-left:48px"><i class="icon icongengduo2" @click="showShare=true"></i></div>
        </div>
    </div>
    <van-share-sheet
        v-model="showShare"
        title="立即分享给好友"
        :options="options"
        @select="onSelect"
    />
    <div style="height:44px"></div>
    <div style="display:flex;align-items: center;">
        <div style="padding:5px 10px;" :style="{color:form.state=='NOAUDIT'?'#FF8518':'#4935ae'}">
            <i class="icon icondanju" style="font-size:50px;"></i>
        </div>
        <div style="width:calc(100% - 90px);">
            <div class="add-ord-title">对账单详情&nbsp;<span style="font-size:12px">({{form.no?form.no:'00000000000'}})</span></div> 
           <div class="add-ord-desc" style="display:flex">
                <div style="flex:1">{{form.merchantName}}</div>
                <div style="width:100px;text-align:right;color:#4c37b6">{{moment(form.operatorTime).format("YYYY-MM-DD")}}</div>
            </div>
        </div>
    </div>
    <div style="background:#fff;margin:0 13px;width:calc(100vw - 25px;);border-top-left-radius:5px;border-top-right-radius:5px;overflow:hidden">
        <div class="sum" style="display:flex;align-items: center;background-color:#4C37B6;padding:10px 0px">
            <div style="text-align:center;color:#FFF;flex:1">
                <div class="sum-val">{{form.amountYuan | money}}</div>
                <div class="sum-txt">对账金额</div>
            </div>
            <div style="width:1px;height:20px;background:#8470e6"></div>
            <div style="text-align:center;color:#FFF;flex:1">
                <div class="sum-val">{{form.paidAmountYuan | money}}</div>
                <div class="sum-txt">已付金额</div>
            </div>
            <div style="width:1px;height:20px;background:#8470e6"></div>
            <div style="text-align:center;color:#FFF;flex:1">
                <div class="sum-val">{{form.giftAmountYuan | money}}</div>
                <div class="sum-txt">优惠金额</div>
            </div>
            <div style="width:1px;height:20px;background:#8470e6"></div>
            <div style="text-align:center;color:#FFF;flex:1">
                <div class="sum-val">{{form.noPaidAmount | money}}</div>
                <div class="sum-txt">未付金额</div>
            </div>
        </div>
        <van-tabs v-model="active" :ellipsis="false">
            <van-tab :title="'采购单据('+tableData.length+')'" name="stock" v-if="tableData.length!=0"></van-tab>
            <van-tab :title="'销售商品 ('+goodsTableData.length+')'" name="goods" v-if="goodsTableData.length!=0"></van-tab>
            <van-tab :title="'预付/预收/费用单据 ('+payTableData.length+')'" name="payment" v-if="payTableData.length!=0"></van-tab>
            <van-tab :title="'批发销售商品 (' + wholeTableData.length + ')'" name="wholesale" v-if="wholeTableData.length!=0"></van-tab>
            <van-tab :title="'商城销售商品 (' + wxShopTableData.length + ')'" name="wxShop" v-if="wxShopTableData.length!=0"></van-tab>
        </van-tabs>
        <div v-if="active=='stock'">
            <detali-table :isShow="isShow" :active="active" :order="form" :details="tableData" bindchangeTable="changeState"></detali-table>
        </div>
        <div v-if="active=='goods'">
            <goods-details-table :isShow="isShow" :order="form" :details="goodsTableData" bindchangeTable="changeState"></goods-details-table>
        </div>
        <div v-if="active=='payment'">
            <detali-table :isShow="isShow" :active="active" :order="form" :details="payTableData" bindchangeTable="changeState"></detali-table>
        </div>
        <div v-if="active=='wholesale'">
            <wholesale-details-table :isShow="isShow" :order="form" :details="wholeTableData" bindchangeTable="changeState"></wholesale-details-table>
        </div>
        <div v-if="active=='wxShop'">
            <wxSaleDetailsTable :isShow="isShow" :order="form" :details="wxShopTableData" bindchangeTable="changeState"></wxSaleDetailsTable>
        </div>
    </div>
    <!-- <div class="fixed-submit" style="width:calc(100vw - 25px);left:13px">
        <div style="width:100px;background-color:#ff8518;display:flex" @click="goBack">
            <div class="btn" >
                <i class="icon iconfanhui1"></i>
                <div class="btn-text">返回</div>
            </div>
        </div>
        <div style="background-color:#4935ae;width:calc(100% - 100px);display: flex;">
            <div class="btn" >
                <div class="btn-text" style="font-size:13px">未付金额:{{form.noPaidAmount | money}}</div>
            </div>
        </div>
    </div> -->
  </div>
</template>

<script>
import detailsTable from './detailsTable';
import goodsDetailsTable from './goodsDetailsTable';
import wholesaleDetailsTable from './wholesaleDetailsTable';
import wxSaleDetailsTable from './wxSaleDetailsTable';

export default {
    components:{
        'detali-table':detailsTable,
        goodsDetailsTable:goodsDetailsTable,
        wholesaleDetailsTable:wholesaleDetailsTable,
        wxSaleDetailsTable:wxSaleDetailsTable
    },
    data() {
        return {
            form: {},
            tableData: [],
            goodsTableData: [],
            payTableData: [],
            wholeTableData: [],
            wxShopTableData: [],
            active: 0,
            showBatchNoModel: false,
            state: 1,
            isShow: false,
            showPreOrderModel: false,
            moreKey: {},
            typeList: [],
            active:'stock',
            priceSetting: '',
            planappoint: '',
            plantype: '',
            planladder: '',
            plandiscount: ''
        }
    },
    created(){
        this.$request.get("statementOrders/statementOrderDetail?id="+this.$route.query.orderId).then(data=>{
            console.log(this.$store.state.supplierInfo.type)
            if(this.$store.state.supplierInfo.type=='JOINT_VENTURE' || this.$store.state.supplierInfo.type=='LEASE'){
                this.form=data.content.jointStatementOrder    
                this.goodsTableData=data.content.details
                this.wholeTableData=data.content.wholeDetails
                this.wxShopTableData=data.content.wxDetails
            }else if(this.$store.state.supplierInfo.type=='NORMAL'){
                this.form=data.content.statementOrder
                this.tableData=data.content.detailList
            }else if(this.$store.state.supplierInfo.type=='CONSIGNMENT'){
                this.form=data.content.conSignMentStatementOrder
                this.goodsTableData=data.content.details
            }else if(this.$store.state.supplierInfo.type=='LEASE'){
                this.form=data.content.statementOrder
                this.tableData=data.content.detailList
            }
            this.payTableData=data.content.expenseList
        })
    },
    methods:{
        changeTab(name, title) {
            this.active=name
        },
        goBack(){
            this.router.go(-1)
        },
        save() {
            this.$request.post("purchaseOrder/handleOrder", {orderId:this.$route.query.id}).then(data => {
                if (data.status == 200) {
                    this.$request.get("purchaseOrder/orderDetail?orderId="+this.$route.query.id).then(data=>{
                        this.form=data.content.order
                        this.tableData=data.content.detailList
                    })
                } else {
                    wx.showToast({
                        icon: 'none',
                        title: data.message
                    })
                }
            })
        },
        closeModle(){
            this.router.go(-1)
        }
    }
}
</script>

<style scoped>

.add-ord-title{
    font-size: 16px;
    padding-bottom:5px;
    border-bottom:1px solid #aaa
}

.add-ord-desc{
    font-size:13px;
}
.order-price{
    color:#F56C6C;
    font-weight: 600
}


.add-tabs{
    font-size:15px !important;
    font-weight:700
}



.model-bg {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 1;
    height: calc(100vh - 65px);
    width: 50vw;
    background-color: rgba(0, 0, 0, 0.78);
  }
  .sum-val{
    font-weight: 600;
    margin-bottom:3px;
  }
  .sum-txt{
    font-size:12px;
    color:#cabfff
  }
</style>


// WEBPACK FOOTER //
// src/views/stateMent/detail.vue